export const NftI18n = {
	zh: {
		'nft-title-1': '三步领<em>空投</em>',
		'nft-title-2': '<em>详细</em>规则',
		'nft-meta-title': 'Payegis NFT 火热首发',
		'nftdetail-meta-title': '链上会 - 分布式商业办公',
		'nft-meta-description':
			'基于区块链分布式账本、分布式公钥基础设施（DPKI）、分布式数字身份（DID）等技术实现“协同、分享、建设”为核心的功能矩阵，打造保障隐私安全的Web3入口，提供一站式 Web3 DAO Kit',
		'nft-btn': '立即报名 享受空投',
		'nft-btn-1': '已报名',
		'nft-step-1': '下载应用',
		'nft-step-2': '创建钱包',
		'nft-step-3': '确认提交',
		'nft-con-1':
			'截止北京时间2023年8月18日在【链上会】平台【智能钱包】板块创建钱包确认提交，即可免费参与领取空投活动',
		'nft-con-2': '链上会将会以周为周期统计人员名单，并且从中随机抽取10位幸运用户发放空投，先到先得。',
		'nft-footer': '*本次活动最终解释权归链上会所属',
		'nft-detail-type-1': '证明链',
		'nft-detail-type-2': '以太坊',
		'nft-detail-message-1': '交易哈希',
		'nft-detail-message-2': '凭证ID',
		'nft-detail-message-3': '创作者',
		'nft-detail-message-4': '拥有者',
		'nft-detail-nft-1': '链上标识',
		'nft-detail-nft-2': '区块链',
		'nft-detail-nft-3': '区块链哈希',
		'nft-detail-nft-4': '作品描述',
		'nft-detail-nft-5': '关于数字藏品',
		'nft-detail-nft-6':
			'数字藏品可以通俗理解为区块链数字凭证。特性为不可分割、不可替代、独一无二。数字藏品常见于文化艺术品领域、知识产权的链上发行、流转、确权等作用，能有效保证链上知识产权，防止篡改、造假等，是区块链技术的一类场景应用。',
	},
	en: {
		'nft-title-1': 'Three<em>Steps</em>',
		'nft-title-2': '<em>Detailed</em>Rules',
		'nft-meta-title': 'Payegis NFT hot starter',
		'nftdetail-meta-title': 'ChainPal - Collaborative Business Suite',
		'nft-meta-description':
			'Based on distributed ledger, decentralized public key infrastructure (DPKI), decentralized identity (DID), ChainPal provides a functional matrix of "Coordinate, Share, and Build" , creating a privacy-preserving Web3 interface, providing One-stop Web3 DAO Kit.',
		'nft-btn': 'Sign Up',
		'nft-btn-1': 'Registered',
		'nft-step-1': 'Download',
		'nft-step-2': 'Create',
		'nft-step-3': 'Submit',
		'nft-con-1':
			'By August 18th, 2023, Beijing time, create a wallet in the [Smart Wallet] section of the [ChainPal] platform and confirm the submission, and you can participate in the airdrop event for free.',
		'nft-con-2':
			'The list of personnel on the chain will be counted on a weekly basis, and 10 lucky users will be randomly selected to distribute airdrops on a first-come-first-served basis.',
		'nft-footer':
			'*ChainPal reserves the right of final interpretation of the event.',
		'nft-detail-type-1': 'Proof',
		'nft-detail-type-2': 'ETH',
		'nft-detail-message-1': 'Transaction Hash',
		'nft-detail-message-2': 'DID',
		'nft-detail-message-3': 'Creator',
		'nft-detail-message-4': 'Owner',
		'nft-detail-nft-1': 'TokenId',
		'nft-detail-nft-2': 'Blockchain',
		'nft-detail-nft-3': 'Blockchain Hash',
		'nft-detail-nft-4': 'Work description',
		'nft-detail-nft-5': 'About digital collections',
		'nft-detail-nft-6':
			'Digital collections can be popularly understood as blockchain digital vouchers. The characteristics are indivisible, irreplaceable and unique. Digital collections are commonly used in the field of cultural works of art, intellectual property distribution, circulation, confirmation and other functions on the chain, which can effectively ensure the intellectual property on the chain, prevent tampering, forgery, etc., and are a kind of scenario application of blockchain technology.',
	},
}
